export class DeepSet<T> extends Set<T> {
  add(element: T): this {
    // check if element is in set
    for (const e of this) {
      if (this.deepCompare(e, element)) return this;
    }
    // element not in set
    super.add(element);
    return this;
  }

  addAll(elements: T[] = []): this {
    elements.forEach((el) => {
      let exists = false;
      for (const e of this) {
        if (this.deepCompare(e, el)) {
          exists = true;
          break;
        }
      }
      if (!exists) {
        super.add(el);
      }
    });
    return this;
  }

  // compare JSON representations of objects
  private deepCompare(a: T, b: T): boolean {
    return JSON.stringify(a) === JSON.stringify(b);
  }
}
